import {DPACreativeNode, DTNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, ServerNode} from 'common/src/modules/nodes/nodes.types';

export function serializeFacebookDPACreative(node: DTNode, newNode: ServerNode) {
  const dpaNode = node as DPACreativeNode;

  return {
    ...newNode,
    catalogId: dpaNode.catalogId ? dpaNode.catalogId : '',
    productSetId: dpaNode.productSetId ? dpaNode.productSetId : '',
    additionalImageIndex: dpaNode.additionalImageIndex,
    utmParams: dpaNode.utmParams,
    type: NodeType.FACEBOOK_DPA_CREATIVE,
    externalAdDescription: dpaNode.externalAdDescription,
    externalAdHeadline: dpaNode.externalAdHeadline,
    externalAdCTA: dpaNode.externalAdCTA,
    externalAdPrimaryText: dpaNode.externalAdPrimaryText,
    previewItemUrls: dpaNode.previewItemUrls,
    adNameTemplate: dpaNode.adNameTemplate,
    landingPageSource: dpaNode.landingPageSource,
    landingPage: dpaNode.landingPage,
    identity: dpaNode.identity,
    trackingPixel: dpaNode.trackingPixel,
    additionalIdentity: dpaNode.additionalIdentity,
    trackingPixels: dpaNode.trackingPixels,
  };
}

